import { Injectable } from '@angular/core';
import { LogLevel, StsConfigStaticLoader } from 'angular-auth-oidc-client';

import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthService {
  createStsConfigLoader(): StsConfigStaticLoader {
    return new StsConfigStaticLoader({
      authority: `${environment.EUA_HOST}/information-risk-management/enterprise-user-auth/v3/partner-pnc`,
      clientId: environment.DEV_PORTAL_APP_CONSUMER_KEY_FRONTEND,
      forbiddenRoute: '/unauthorized',
      logLevel: LogLevel.Warn,
      redirectUrl: `${window.location.origin}/callback`,
      renewTimeBeforeTokenExpiresInSeconds: 300,
      responseType: 'code',
      scope: 'openid nwapi',
      silentRenew: true,
      disableRefreshTokenOfflineAccessScopeWarning: true,
      /**
        EUAv3 non-prod: token issuer ("https://identity-pt.nationwide.com") differs from the
        well-known URL host ("https://api.identity-test.nwie.net/.../partner-pnc"), so v20’s
        strict issuer check fails during init. Temporarily relax in lower envs; re-enable if and when
        issuer and discovery endpoint are aligned.
      **/
      strictIssuerValidationOnWellKnownRetrievalOff: true,
      triggerRefreshWhenIdTokenExpired: false,
      unauthorizedRoute: '/unauthorized',
      useRefreshToken: true,
    });
  }
}
